module.exports = __webpack_public_path__ + "img/table-des-matieres.35c8e469.png";